import * as React from "react";

export interface HStackProps extends React.HTMLAttributes<HTMLDivElement> {
  gap?: React.CSSProperties["gap"];
  align?: React.CSSProperties["alignItems"];
  justify?: React.CSSProperties["justifyContent"];
  wrap?: boolean;
}

const HStack = ({
  gap = "var(--space-xs)",
  align,
  justify,
  wrap,
  style,
  ...props
}: HStackProps) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        gap,
        alignItems: align,
        justifyContent: justify,
        flexWrap: wrap ? "wrap" : undefined,
        ...style,
      }}
      {...props}
    />
  );
};

export { HStack };
